<!-- Page clicker -->
<et-atoms-native-pages-clicker
  [totalPages]="totalPages"
  [currentPage]="page"
  [disableNav]="true"
  (changePage)="changePage.emit($event)"
></et-atoms-native-pages-clicker>

<!-- Divider -->
<div class="border-l border-neutral h-9"></div>

<!-- The button to advance navigation modal -->
<div class="-ml-2">
  <label (click)="openNav()" class="btn btn-circle btn-ghost">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_79_171)">
        <path
          d="M23.7824 6.58491L17.4149 0.217408C17.2724 0.0749084 17.0849 -9.15527e-05 16.8824 -9.15527e-05H8.24992C7.83742 -9.15527e-05 7.49992 0.337408 7.49992 0.749908V4.05741C4.61242 4.91991 2.49742 7.59741 2.49742 10.7624C2.49742 12.4199 3.08242 13.9499 4.04992 15.1499L0.217422 18.9824C-0.0750781 19.2749 -0.0750781 19.7474 0.217422 20.0399C0.367422 20.1899 0.554922 20.2574 0.749922 20.2574C0.944922 20.2574 1.13242 20.1824 1.28242 20.0399L5.11492 16.2074C5.81242 16.7699 6.62242 17.2049 7.49992 17.4674V23.2499C7.49992 23.6624 7.83742 23.9999 8.24992 23.9999H23.2499C23.6624 23.9999 23.9999 23.6624 23.9999 23.2499V7.11741C23.9999 6.91491 23.9174 6.72741 23.7824 6.58491ZM9.50242 5.26491C12.5324 5.26491 14.9999 7.73241 14.9999 10.7624C14.9999 13.7924 12.5324 16.2599 9.50242 16.2599C6.47242 16.2599 4.00492 13.7924 4.00492 10.7624C4.00492 7.73241 6.47242 5.26491 9.50242 5.26491ZM22.4999 22.5074H8.99992V17.7449C9.16492 17.7599 9.32992 17.7674 9.50242 17.7674C13.3649 17.7674 16.4999 14.6249 16.4999 10.7699C16.4999 6.91491 13.3574 3.77241 9.50242 3.77241C9.33742 3.77241 9.16492 3.78741 8.99992 3.79491V1.50741H16.5749L16.8824 1.81491V7.11741H22.1849L22.4924 7.42491V22.4999L22.4999 22.5074Z"
          fill="#00303C"
        />
      </g>
      <defs>
        <clipPath id="clip0_79_171">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </label>

  <et-atoms-native-popup
    #advanceNavigation
    [popupTemplate]="navigationTemplate"
    [offsetX]="0"
    [offsetY]="4"
    [disabled]="true"
    [positions]="popupPosition"
    [flexibleDimensions]="true"
    [growAfterOpen]="true"
    (menuClose)="showOverlay.emit(false)"
  ></et-atoms-native-popup>
</div>

<!-- Navigation template -->
<ng-template #navigationTemplate>
  <et-atoms-native-advanced-navigation
    [style.width.px]="width - 110"
    [totalPages]="totalPages"
    [currentPage]="page"
    [file]="file"
    (changePage)="changePage.emit($event)"
    (closeNav)="showOverlay.emit(false); advanceNavigation.onClose()"
  ></et-atoms-native-advanced-navigation>
</ng-template>
